/** @format */

import { DynamicTemplateLoader, TaggingService } from '@shared/data-access/services';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HomrContentResolve } from '../../common/resolve/homr.resolve';
import { KrakenService } from '@shared/components/kraken-service';
import { NoContentComponent } from '../no-content/no-content.component';
import { PageHeaderComponent } from './static-component/page-header/page-header.component';
import { StaticComponent } from './static-component/static.component';

@NgModule({
  imports: [
    CommonModule,
    // TODO: CommonCoreModule
  ],
  declarations: [NoContentComponent, PageHeaderComponent, StaticComponent],
  providers: [DynamicTemplateLoader, HomrContentResolve, KrakenService, TaggingService],
  exports: [NoContentComponent, PageHeaderComponent, StaticComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class StaticModule {}
